import axios from "axios";
import SnackbarService from "../../../app/components/theme/Snackbar/service";
import BlockUIService from "../../../app/components/theme/BlockUI/service";
import { AppDispatch } from "../../../app/store";
import { store } from "../../../app/store/user";

const { REACT_APP_API_LOCATION } = process.env;

const LOGIN = `${REACT_APP_API_LOCATION}/Admin/Login`;

const api = {
  login: (data: any) => async (dispatch: AppDispatch) => {
    BlockUIService.show();
    try {
      const response = await axios.post(LOGIN, data);
      localStorage.setItem('samii-admin-session-token', response.data.token);
      dispatch(store({ id: response.data.id, name: response.data.username }));
    } catch (e: any) {
      const message = e?.response?.data?.error?.message;
      await SnackbarService.show(message || 'Ha ocurrido un problema', 'error');
      throw e;
    } finally {
      BlockUIService.hide();
    }
  },
};

export default api;
